import {
  adOAuthProviders,
  communicationOAuthProviders,
  storeOAuthProviders,
  type ConnectionOAuthProvider,
} from "./storeBindingOAuthClient";
const oauthPopupMessageType = "merry.connection.oauth_result";
interface OAuthPopupMessage { error?: string; operationID?: string; operationStatus?: string; provider: ConnectionOAuthProvider; status: "failed" | "succeeded"; type: typeof oauthPopupMessageType; }
export function parseOAuthPopupMessage(event: MessageEvent<unknown>): OAuthPopupMessage | null {
  if (event.origin !== window.location.origin || !isRecord(event.data)) return null;
  if (
    event.data.type !== oauthPopupMessageType ||
    (event.data.status !== "succeeded" && event.data.status !== "failed") ||
    typeof event.data.provider !== "string" ||
    !isConnectionOAuthProvider(event.data.provider)
  ) {
    return null;
  }
  return {
    ...(typeof event.data.error === "string" ? { error: event.data.error } : {}),
    ...(typeof event.data.operationID === "string"
      ? { operationID: event.data.operationID }
      : {}),
    ...(typeof event.data.operationStatus === "string"
      ? { operationStatus: event.data.operationStatus }
      : {}),
    provider: event.data.provider,
    status: event.data.status,
    type: oauthPopupMessageType,
  };
}

export function openOAuthPopup(provider: ConnectionOAuthProvider, label: string) {
  const width = Math.min(920, Math.max(720, Math.floor(screen.availWidth * 0.58)));
  const height = Math.min(760, Math.max(640, Math.floor(screen.availHeight * 0.78)));
  const left = Math.max(0, Math.floor((screen.availWidth - width) / 2));
  const top = Math.max(0, Math.floor((screen.availHeight - height) / 2));
  const popup = window.open(
    "about:blank",
    `merry_${provider}_oauth`,
    [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      "popup=yes",
      "resizable=yes",
      "scrollbars=yes",
    ].join(","),
  );
  if (!popup) return null;
  popup.document.title = `${label} 授权`;
  const status = popup.document.createElement("div");
  status.textContent = `正在准备 ${label} 授权，请稍候…`;
  Object.assign(status.style, {
    color: "#19262b",
    display: "grid",
    font: "16px 'Noto Sans SC', sans-serif",
    minHeight: "100vh",
    placeItems: "center",
  });
  popup.document.body.replaceChildren(status);
  popup.document.body.style.margin = "0";
  return popup;
}

export function oauthErrorMessage(error: unknown) {
  const code = error instanceof Error ? error.message : String(error);
  const messages: Readonly<Record<string, string>> = {
    invalid_shop_domain: "店铺域名格式不正确",
    oauth_auth_url_missing: "服务端没有返回授权地址",
    oauth_auth_url_untrusted: "授权地址未通过安全校验",
    oauth_popup_closed: "授权窗口已被关闭",
  };
  return messages[code] ?? "授权暂时未完成，请稍后重试";
}

function isRecord(value: unknown): value is Record<string, unknown> { return typeof value === "object" && value !== null && !Array.isArray(value); }
function isConnectionOAuthProvider(provider: string): provider is ConnectionOAuthProvider {
  return [
    ...storeOAuthProviders,
    ...adOAuthProviders,
    ...communicationOAuthProviders,
  ].includes(provider as ConnectionOAuthProvider);
}
